import { type FC, useEffect } from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'dibs-react-intl';

import Favorite from 'dibs-icons/exports/Favorite.ts';

import { trackGlobalNavEvent } from '../Notifications/userNotifications/userNotificationsTracking.ts';

import styles from './FavoritesDropdownEmpty.module.module.css';
import dibsCss from 'dibs-css';

const FavoritesDropdownEmpty: FC = () => {
    useEffect(() => {
        trackGlobalNavEvent({
            stepInteractionName: 'favorites window empty state displayed',
        });
    }, []);

    return (
        <div
            className={classnames(
                dibsCss.sassyFontBody,
                dibsCss.flex,
                dibsCss.flexCol,
                dibsCss.itemsCenter,
                dibsCss.pMedium,
                dibsCss.ptSmall,
                dibsCss.gapSmall
            )}
        >
            <div
                className={classnames(
                    styles.iconContainer,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.justifyCenter,
                    dibsCss.bgTangerine50,
                    dibsCss.roundedFull,
                    dibsCss.fillWarningprimary
                )}
            >
                <Favorite variation="40" />
            </div>
            <div className={classnames(dibsCss.maxW400px, dibsCss.textCenter)}>
                <div className={dibsCss.textBodyMediumHeavy}>
                    <FormattedMessage
                        id="dbl.FavoritesDropdownEmpty.title"
                        defaultMessage="Save items you love"
                    />
                </div>
                <FormattedMessage
                    id="dbl.FavoritesDropdownEmpty.subtitle"
                    defaultMessage="Track price drops and get exclusive offers for your favorited items."
                />
            </div>
        </div>
    );
};

export { FavoritesDropdownEmpty };
